import { SVGProps } from 'react';

const Redo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 13h6V7m0 6-3-2.7A9 9 0 0 0 12 8a9 9 0 0 0-9 9"
    />
  </svg>
);
export default Redo;
